import { useApolloClient } from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import { useState, useEffect } from 'react'

export const useApi = (api) => {
  const [data, setData] = useState({
    data: null,
    error: null,
    loading: true,
  })
  const client = useApolloClient()
  const { user: authUser } = useAuth0()

  const refresh = async () => {
    try {
      const personId = authUser?.['custom:person_id']
      const datums = await api(client, personId, true)
      setData({ ...data, data: datums, loading: false })
    } catch (ex) {
      setData({ ...data, error: ex, loading: false })
    }
  }

  useEffect(() => {
    let isMounted = true
    const saturateData = async () => {
      try {
        const personId = authUser?.['custom:person_id']
        const datums = await api(client, personId)
        if (isMounted)
          setData({
            data: datums,
            loading: false,
            error: false,
          })
      } catch (ex) {
        if (isMounted) setData({ error: ex })
      }
    }
    saturateData()
    return () => (isMounted = false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api])

  return { data, refresh }
}
